import { Confirmation, EditPassword, Error } from '../../../components/Settings/Password';

export default {
  1: { ViewToRender: EditPassword },
  2: { ViewToRender: Confirmation },
  3: { ViewToRender: Error },
};
